/*
Example state:

export default {
  byId: {
    ans1: {
      id: 'ans1',
      name: 'Can you guess who is NOT cool?',
      content: {
        public: {
          bodyHtml: 'Jdom is not cool.',
        },
      },
    },
    ans2: {
      id: 'ans2',
      name: 'Can you guess who IS cool?',
      content: {
        public: {
          bodyHtml: 'Kaylee is cool.',
        },
      },
    },
  },
  allIds: ['ans1', 'ans2'],
  quickActions: [
    { name: 'Order Status', content: { type: 'EXTERNAL', value: 'www.google.com' } },
    { name: 'Baggage Fees', content: { type: 'INTERNAL', value: 'snippet-1' } },
  ],
  searchResultAnswerIds: ['ans1', 'ans2'],
  selectedAnswer: null,
};

*/

export default {
  byId: {},
  allIds: [],
  quickActions: [],
  searchResultAnswerIds: [],
  selectedAnswer: null,
};
